import styled from 'styled-components';
import FluffyIcon, { Icons, IconSizes, IconVariants } from '@gotamedia/fluffy/Icon';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-uljxlw-0"
})(["max-width:545px;display:flex;margin-top:12px;font-family:'Sanomat Sans Text';font-style:normal;font-weight:400;font-size:12px;line-height:16px;"]);
const Text = styled.p.withConfig({
  displayName: "style__Text",
  componentId: "sc-uljxlw-1"
})(["color:#8A8A8D;"]);
const MoreInfo = styled.p.withConfig({
  displayName: "style__MoreInfo",
  componentId: "sc-uljxlw-2"
})(["color:#0182C9;margin:0 4px;display:flex;cursor:pointer;"]);
const Icon = styled(FluffyIcon).attrs(() => {
  return {
    icon: Icons.ChevronDown,
    size: IconSizes.Micro,
    variant: IconVariants.Solid
  };
}).withConfig({
  displayName: "style__Icon",
  componentId: "sc-uljxlw-3"
})(["color:#0182C9;margin:auto 0;"]);
export { Wrapper, Text, MoreInfo, Icon };